import { connect, useDispatch } from "react-redux";
import Image from '../../../../components/Image';
import Icon from '../../../../components/Icon';
import { medals } from "../../../../constants/medals";
import arrowForwardUpRight from '../../../../assets/icons/arrow_forward_up_right-semibold.svg'
import closeCircled from '../../../../assets/icons/close_circled.svg'
import { useWindowSize } from "../../../../hooks/useWindowSize";
import { useCallback, useMemo } from "react";
import { CategoryDto } from "../../../../types/category";
import {
  Container,
  Medal,
  Content,
  ExploreButton,
  CloseButton,
  Flex
} from './styles'
import { showPreference } from "../../../../helpers/preferenceVisible";
import { savePreference } from "../../../../store/actions/preferences";
import UnlockedCategoryMedal from "../../../components/UnlockedCategoryMedal";

const UnlockedCategoriesBadged = ({ allCategories, group, preferences, preferencesStates }) => {
  const { isMobile } = useWindowSize()
  const dispatch = useDispatch()

  const getLink = useCallback((category) => {
    return `/group/${group?.id}/p/c/${category?.id}`
  }, [group])

  const onClose = (idCategory) => {
    dispatch(
      savePreference({
        preferenceSlug: `unlocked-category-badge-${idCategory}`,
        preferenceValue: false,
      })
    );
  }

  const unlockedCategories = useMemo(() => {
    return allCategories
      ?.filter(item => item?.is_unlockable)
      ?.filter(item => item?.user_access_data?.is_unlocked)
      ?.filter(item => group?.library_template_view === 'by_category' ? item?.last_posts?.length > 0 : true)
      ?.filter(item => !!item?.locked_ordinal)
      ?.filter(item => {
        const show = showPreference({
          preferences,
          preferencesStates,
          id: `unlocked-category-badge-${item?.id}`,
        })

        return show
      })
      ?.sort((a, b) => a.locked_ordinal - b.locked_ordinal);
  }, [group, allCategories, preferences, preferencesStates]);


  console.log(unlockedCategories)

  if (!unlockedCategories || (unlockedCategories && unlockedCategories.length <= 0) || preferencesStates.loading) {
    return <></>
  }

  return (
    <>
      {isMobile && (<div style={{ height: 26 }} />)}

      <Flex>
        {unlockedCategories?.map((category: CategoryDto) => {
          console.log({ name: category?.name, lockedorder: category?.locked_ordinal })
          return (
            <Container unlockOrder={category?.locked_ordinal}>
              {onClose && (
                <CloseButton onClick={() => onClose(category?.id)}>
                  <Icon icon={closeCircled} size="24px" color="black" />
                </CloseButton>
              )}

              <UnlockedCategoryMedal category={category} width={isMobile ? "65px" : "60px"} height="auto" />

              <Content>
                <h4>Desbloqueaste un nuevo nivel:</h4>
                <div style={{ height: 8 }} />
                <h2>{category?.name}</h2>
              </Content>

              <ExploreButton
                onClick={() => onClose(category?.id)}
                href={getLink(category)}
                target="_blank"
              >
                <span>Explorar ahora</span>
                <Icon icon={arrowForwardUpRight} size={isMobile ? "14px" : "24px"} color="white" />
              </ExploreButton>
            </Container>
          )
        })}
      </Flex>
    </>
  )
}

const state = ({ categoryStore, groupStore, preferencesStore }) => {
  const { data: allCategories } = categoryStore.allCategories;
  const { data: group } = groupStore.group;
  const { data: preferences, states: preferencesStates } = preferencesStore.preferences;

  return {
    group,
    allCategories,
    preferences,
    preferencesStates
  };
};

export default connect(state)(UnlockedCategoriesBadged)